var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGamespot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-5 -5 741.79 741.81",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M365.89 0C163.81 0 0 163.83 0 365.91s163.81 365.9 365.89 365.9 365.9-163.81 365.9-365.9S568 0 365.89 0Zm0 684.24c-175.81 0-318.33-142.53-318.33-318.33S190.08 47.58 365.89 47.58 684.23 190.1 684.23 365.91 541.71 684.24 365.89 684.24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M508.25 506.5c-8.35-5.84-19.41-8.42-31.6-8.42-9.51 0-33.75 3.88-71.5 11.7-19.88 4.27-35.17 5.61-46.07 5.61-43.63 0-80.47-14.35-112.21-43.36-30.26-29.3-46.21-64.56-46.21-105.9 0-42.29 14.94-77.74 46-106.05 31.92-29.35 72.16-43.65 121.16-43.65 32.09 0 57.48 2.21 78.49 7.5 3.24.65 19.22 5.84 47.56 16.19l-11.58 44.3c-14.15-5.81-24.73-9.14-32.43-10.73a169.56 169.56 0 0 0-46.22-6.16c-31.92 0-56.85 10.13-75.72 30.29-17.42 18.52-25.53 41.72-25.53 68.73 0 26.67 7.79 48.47 23.74 66.42 16.17 18.15 35.2 26.03 57.16 26.03 8.48 0 16-1.34 21.83-6.58a27.1 27.1 0 0 0 9-20.83v-60.52h94.15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamespot);
export default __webpack_public_path__ + "static/media/gamespot.b464981ab40c522c89264bc9103047ff.svg";
export { ForwardRef as ReactComponent };